import React, {useContext, useState} from "react"
import Row from "@amzn/meridian/row";
import {FormattedMessage} from "react-intl";
import ButtonGroup, {ButtonOption} from "@amzn/meridian/button-group"
import {StageFilterContext} from "./context/StageFilterContext";
import {CART_VIEW, DEFAULT_CAPABILITIES, ROUTE_VIEW} from "../util/Constants";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const StageViewSelector = () => {
    const [cartView, setCartView] = useState(CART_VIEW);
    const {dispatchF} = useContext(StageFilterContext)
    const {configViewModel} = useContext(CapabilityContext)
    const {spacingInset_shorthand4} = useDeviceLayout()
    
    const toggleView = (newValue) => {
        setCartView(newValue);
        dispatchF({type: 'SELECT_VIEW_TYPE', viewType: newValue})
    };

    return (
        <div>
            {!DEFAULT_CAPABILITIES.includes(configViewModel.capability) || configViewModel.stationConfig.pickStageDecoupleEnabled  ?
                <Row spacingInset={spacingInset_shorthand4}>
                    <ButtonGroup value={cartView} onChange={toggleView}>
                        <ButtonOption value={CART_VIEW}>
                            <FormattedMessage id="stageOverall.cartView" defaultMessage="Cart View"/>
                        </ButtonOption>
                        <ButtonOption value={ROUTE_VIEW}>
                            <FormattedMessage id="stageOverall.routeView" defaultMessage="Route View"/>
                        </ButtonOption>
                    </ButtonGroup>
                </Row>
                : null
            }
        </div>
    )
}

export default StageViewSelector



// WEBPACK FOOTER //
// ./src/components/stageStatus/StageViewSelector.js